import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import WOMPath from './WOM.path';
import MovieList from './movieList/movieList.index';
import DrawerMenu from '../includes/drawerMenu/drawerMenu.index';
import Header from '../includes/header/header.index';
import MovieDetail from './movieDetail/movieDetail.index';
import Person from './person/person.index';

const WOM: React.FC = () => {
    return (
        <Router>
            <div className="wom-container">
                <DrawerMenu />
                <div className="wom-main">
                    <Header />
                    <div className="wom-content">
                        <Switch>
                            <Route path={WOMPath.person()} component={Person} exact />
                            <Route path={WOMPath.movieDetail()} component={MovieDetail} exact />
                            <Route path={WOMPath.movieList()} component={MovieList} exact />
                            <Route path="*">
                                <Redirect to="/" />
                            </Route>
                        </Switch>
                    </div>
                </div>
            </div>
        </Router>
    )
}

export default WOM;
